import './StatusPage.css';

interface EditionHeaderProps {
  date: string;
  edition: string;
  generatedAt: string;
}

export function EditionHeader({ date, edition, generatedAt }: EditionHeaderProps) {
  const formattedDate = new Date(date).toLocaleDateString('en-GB', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const formattedTime = new Date(generatedAt).toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit'
  });

  const editionLabel = edition.charAt(0).toUpperCase() + edition.slice(1);

  return (
    <div className="edition-header">
      <h1 className="edition-header__title">Pipeline Status</h1>
      <div className="edition-header__metadata">
        <span className="edition-header__edition">{editionLabel} Edition</span>
        <span className="edition-header__separator">•</span>
        <span className="edition-header__date">{formattedDate}</span>
        <span className="edition-header__separator">•</span>
        <span className="edition-header__time">Generated at {formattedTime}</span>
      </div>
    </div>
  );
}
